import CoursesData from './CoursesData';

export default CoursesData;
